import {Divider} from '@/components/ui/divider/Divider'
import {useTranslation} from '@/translations/i18n'
import {MedicalReportSectionTitle} from '../medical-report-section-title/MedicalReportSectionTitle'
import {Controller, useFormContext} from 'react-hook-form'
import {MedicalReportTextAreaSections} from '../medical-report-text-area-sections/MedicalReportTextAreaSections'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {closeProjectReasonsMapToLabel, closeProjectReportToSection} from '../../utils'
import {CloseProjectReportsSchema, MedicalReportFieldsSchema} from '../../formSchemas'
import {z} from 'zod'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {MedicalReportEndDateField} from '@/features/medical-reports/components/medical-report-end-date-field/MedicalReportEndDateField'

const CloseContinuosProjectAdditionalInfoSchema = MedicalReportFieldsSchema.pick({
    closureReason: true,
    endDate: true,
    project: true
})
type CloseContinuosProjectAdditionalInfoSchema = z.infer<typeof CloseContinuosProjectAdditionalInfoSchema>

export const CloseContinuousProjectSections = () => (
    <>
        <ReportSections />
        <Divider direction="horizontal" />
        <AdditionalInfoSectionForm />
    </>
)

const ReportSections = () => {
    const {t} = useTranslation()
    return (
        <>
            <MedicalReportSectionTitle>{t('commons:report', {count: 1})}</MedicalReportSectionTitle>
            <MedicalReportTextAreaSections
                sectionsMap={closeProjectReportToSection}
                schema={CloseProjectReportsSchema}
            />
        </>
    )
}

const AdditionalInfoSectionForm = () => {
    const {t} = useTranslation()
    const form = useFormContext<CloseContinuosProjectAdditionalInfoSchema>()

    return (
        <>
            <MedicalReportSectionTitle>{t('commons:additional_info')}</MedicalReportSectionTitle>
            <FormSection title={t('medical_records:closure_reason')}>
                <Flexbox gap={2}>
                    <Controller
                        control={form.control}
                        name={'closureReason'}
                        render={({field, fieldState}) => (
                            <InputSelect
                                label={t('medical_records:select_closure_reason')}
                                value={field.value ?? undefined}
                                placeholder={t('medical_records:select_an_option_placeholder')}
                                optionsMap={closeProjectReasonsMapToLabel}
                                errorMessage={fieldState.error?.message}
                                onChange={field.onChange}
                            />
                        )}
                    />

                    <MedicalReportEndDateField />
                </Flexbox>
            </FormSection>
        </>
    )
}
